module.exports = __webpack_public_path__ + "media/activity-level/cavapoo-hyperactive-dcdb355d.svg";